"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var link_1 = __importDefault(require("next/link"));
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var LoginGiftcodeBonus_1 = __importDefault(require("../../common/LoginGiftcodeBonus"));
var useGiftcodeBonus_1 = require("../../common/LoginGiftcodeBonus/useGiftcodeBonus");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useInitialValues_1 = require("./useInitialValues");
var useValidateSchema_1 = require("./useValidateSchema");
var SwitchAuthType_1 = __importDefault(require("../SwitchAuthType"));
var navigation_1 = require("next/navigation");
var Lockr = __importStar(require("lockr"));
var AUTH_TYPE = 'authType';
var lockrWrapper = function (fn) {
    if (typeof window !== 'undefined')
        return fn();
};
var LogInNew = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.withLabels, withLabels = _f === void 0 ? true : _f, isUserWasAuth = _a.isUserWasAuth, _g = _a.showSignUp, showSignUp = _g === void 0 ? true : _g;
    var t = (0, next_intl_1.useTranslations)('translation');
    var searchParams = (0, navigation_1.useSearchParams)();
    var lang = (0, next_intl_1.useLocale)();
    var backUrl = searchParams.get('back');
    var closeModal = (0, apps_shared_1.useCloseModal)(true);
    var tErr = (0, next_intl_1.useTranslations)('errors');
    var _h = (0, react_1.useState)(lockrWrapper(function () { return Lockr.get(AUTH_TYPE); }) || 'email'), authType = _h[0], setAuthType = _h[1];
    var validateSchema = (0, useValidateSchema_1.useValidateSchema)({ authType: authType });
    var initialValues = (0, useInitialValues_1.useInitialValues)();
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var forgotPasswordUrl = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.FORGOT_PASS, true);
    var forgotPasswordPhoneUrl = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.FORGOT_PASS_PHONE, true);
    var openLogInBonusCongrats = (0, apps_shared_1.useOpenLogInBonusCongrats)();
    var closeWindow = (0, apps_shared_1.useCloseModal)();
    var _j = (0, useGiftcodeBonus_1.useGiftcodeBonus)(), giftcodeBonus = _j.bonus, promoId = _j.promoId;
    var config = (0, swr_hooks_1.useConfig)();
    var geo = (0, swr_hooks_1.useGeo)();
    var router = (0, navigation_1.useRouter)();
    (0, react_1.useEffect)(function () {
        if (isUserWasAuth && isAuth) {
            if (backUrl)
                return router.replace(backUrl);
            router.replace('/');
        }
    }, [isUserWasAuth, router, isAuth, backUrl]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if ((((_a = geo === null || geo === void 0 ? void 0 : geo.data) === null || _a === void 0 ? void 0 : _a.geoData.countryCode) &&
            ((_b = geo === null || geo === void 0 ? void 0 : geo.data) === null || _b === void 0 ? void 0 : _b.geoData.countryCode) === 'UZ') ||
            lang === 'uz') {
            Lockr.set('authType', 'phone');
            setAuthType('phone');
        }
        else {
            Lockr.set('authType', 'email');
            setAuthType('email');
        }
    }, [(_c = (_b = geo === null || geo === void 0 ? void 0 : geo.data) === null || _b === void 0 ? void 0 : _b.geoData) === null || _c === void 0 ? void 0 : _c.countryCode]);
    var activatePromocode = (0, swr_hooks_1.useActivatePromocode)({}).activatePromocode;
    var signUpUrl = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL, true);
    var _k = (0, swr_hooks_1.useLogin)({
        successAction: function () {
            if (giftcodeBonus && promoId) {
                openLogInBonusCongrats();
                activatePromocode({ basePromoId: promoId });
            }
            else if (backUrl)
                router.push(backUrl);
            else
                closeWindow();
            if ((config === null || config === void 0 ? void 0 : config.version) &&
                (config === null || config === void 0 ? void 0 : config.version) === 'licensed' &&
                typeof window !== 'undefined' &&
                (config === null || config === void 0 ? void 0 : config.redirectRouter))
                return (window.location.href = config.redirectRouter);
        },
    }), login = _k.login, isSubmitting = _k.isSubmitting, error = _k.error;
    var onSubmitHandler = (0, react_1.useCallback)(function (values) {
        var loginValue = authType === 'email'
            ? values === null || values === void 0 ? void 0 : values.email
            : authType === 'phone'
                ? "+".concat(values === null || values === void 0 ? void 0 : values.phone)
                : undefined;
        login({
            login: loginValue,
            password: values.password,
        });
    }, [login, authType]);
    var setAuthTypeHandler = function (type) {
        setAuthType(type);
        lockrWrapper(function () { return Lockr.set(AUTH_TYPE, type); });
    };
    return (react_1.default.createElement(ui_components_1.Modal, { width: "420px", padding: "16px", className: styles_module_scss_1.default.modalSignIn, onClose: closeModal, saveSize: true, overflowY: "visible" },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.welcomeBack }, t('welcomeBack')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.logo },
            react_1.default.createElement("img", { src: "/img/logo.svg", alt: "logo" })),
        (config === null || config === void 0 ? void 0 : config.enabledEmailAndPhoneSignUp) ? (react_1.default.createElement(SwitchAuthType_1.default, { authType: authType, setAuthType: setAuthTypeHandler, geo: (_e = (_d = geo === null || geo === void 0 ? void 0 : geo.data) === null || _d === void 0 ? void 0 : _d.geoData) === null || _e === void 0 ? void 0 : _e.countryCode })) : null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
            react_1.default.createElement(LoginGiftcodeBonus_1.default, null),
            react_1.default.createElement(react_final_form_1.Form, { initialValues: initialValues, onSubmit: onSubmitHandler, validate: (0, apps_shared_1.formValidator)(validateSchema), render: function (_a) {
                    var handleSubmit = _a.handleSubmit, submitting = _a.submitting;
                    return (react_1.default.createElement("form", { onSubmit: handleSubmit },
                        react_1.default.createElement("div", null,
                            authType === 'email' ? (react_1.default.createElement(react_final_form_1.Field, { name: "email", render: function (_a) {
                                    var input = _a.input, meta = _a.meta;
                                    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                        react_1.default.createElement(ui_components_1.InputText, __assign({}, input, { mode: "light", placeholder: "user@gmail.com", labelText: withLabels ? t('email') : undefined, withRequiredLabel: true, helperButton: meta.error && meta.touched && { type: 'error' } })),
                                        meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, meta.error))));
                                } })) : null,
                            authType === 'phone' ? (react_1.default.createElement(react_final_form_1.Field, { name: "phone", render: function (_a) {
                                    var _b, _c, _d, _e;
                                    var input = _a.input, meta = _a.meta;
                                    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                        react_1.default.createElement(ui_components_1.PhoneInput, __assign({}, input, { mode: "light", countryCodeEditable: true, errors: meta.error && meta.touched, helperButton: meta.error && meta.touched && { type: 'error' }, placeholder: t("customer.phone.placeholder"), country: ((_c = (_b = geo === null || geo === void 0 ? void 0 : geo.data) === null || _b === void 0 ? void 0 : _b.geoData) === null || _c === void 0 ? void 0 : _c.countryCode)
                                                ? (_e = (_d = geo === null || geo === void 0 ? void 0 : geo.data) === null || _d === void 0 ? void 0 : _d.geoData) === null || _e === void 0 ? void 0 : _e.countryCode.toLowerCase()
                                                : undefined })),
                                        meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, meta.error))));
                                } })) : null,
                            react_1.default.createElement(react_final_form_1.Field, { name: "password", render: function (_a) {
                                    var input = _a.input, meta = _a.meta;
                                    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                        react_1.default.createElement(ui_components_1.InputPassword, __assign({}, input, { mode: "light", placeholder: t('enterPassword'), withRequiredLabel: true, labelText: withLabels ? t('password') : undefined, hasError: meta.error && meta.touched })),
                                        meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, meta.error))));
                                } }),
                            react_1.default.createElement("div", { className: styles_module_scss_1.default.mainErrorWrapper }, error && (react_1.default.createElement(ui_components_1.ErrorText, { style: {
                                    width: '100%',
                                    textAlign: 'center',
                                } },
                                react_1.default.createElement("span", { dangerouslySetInnerHTML: {
                                        __html: tErr.raw(error),
                                    } }))))),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("br", null),
                            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                                react_1.default.createElement(ui_components_1.FixedButton, { type: "submit", loading: isSubmitting || submitting, text: "upper", width: "100%", maxWidth: "100%" }, t('signin'))),
                            react_1.default.createElement("div", { className: styles_module_scss_1.default.centerLinkWrapper },
                                showSignUp && (react_1.default.createElement("div", { className: styles_module_scss_1.default.noAccount },
                                    t('noAccount'),
                                    ' ',
                                    react_1.default.createElement(link_1.default, { className: styles_module_scss_1.default.signUp, href: signUpUrl }, t('signup')))),
                                react_1.default.createElement(link_1.default, { className: styles_module_scss_1.default.forgot, href: authType === 'phone'
                                        ? forgotPasswordPhoneUrl
                                        : forgotPasswordUrl }, t('ifForgotPassword'))))));
                } }))));
};
exports.default = LogInNew;
